import { ROLES, checkPermissionExistence, userPermission } from "./index";

const onlyCollegeHeadCoach = () => {
  checkPermissionExistence();
  return userPermission() === ROLES[1];
};

const exceptCollegeHeadCoach = () => {
  checkPermissionExistence();
  const roles = ROLES.filter(role => role !== ROLES[1]);
  return roles.includes(userPermission());
};

const onlyCollegeNormalCoach = () => {
  checkPermissionExistence();
  return userPermission() === ROLES[4];
};

const exceptCollegeNormalCoach = () => {
  checkPermissionExistence();
  const roles = ROLES.filter(role => role !== ROLES[4]);
  return roles.includes(userPermission());
};

const onlyCollegeProfileMaintainer = () => {
  checkPermissionExistence();
  return userPermission() === ROLES[5];
};

const exceptCollegeProfileMaintainer = () => {
  checkPermissionExistence();
  const roles = ROLES.filter(role => role !== ROLES[5]);
  return roles.includes(userPermission());
};

const onlyCollegeCoach = () => {
  return (
    onlyCollegeHeadCoach() ||
    onlyCollegeNormalCoach() ||
    onlyCollegeProfileMaintainer()
  );
};

const exceptCollegeCoach = () => {
  return (
    exceptCollegeHeadCoach() &&
    exceptCollegeNormalCoach() &&
    exceptCollegeProfileMaintainer()
  );
};

export default {
  onlyCollegeHeadCoach,
  exceptCollegeHeadCoach,
  onlyCollegeNormalCoach,
  exceptCollegeNormalCoach,
  onlyCollegeProfileMaintainer,
  exceptCollegeProfileMaintainer,
  onlyCollegeCoach,
  exceptCollegeCoach
};
